import {BaseAttribute} from "@/pages/AppPages/Events/attribute";
import httpClient from "@/http";
import api from "@/api";

const SURVEY_CONCLUSION = {
    1: 'Не проявляет немотивированную агрессию, подлежит возврату в среду обитания',
    2: 'Проявляет немотивированную агрессию, не подлежит возврату в среду обитания',
    3: 'Необходимо провести повторное тестирование через 7 дней'
}

export class SurveyEventAttributes extends BaseAttribute{

    static stagesMetadata;


    constructor(initObjectParams, initClassProperties) {
        super(initObjectParams);
        this.actNumber = null;
        this.actDate = null;
        this.dogHandler = null;
        this.vetSpecialist = null;
        this.conclusion = null;  // старое поле
        this.conclusionChoice = null; // варианты заключений для акта
        this.votedFor = 0;
        this.votedAgainst = 0;
        this.specialOpinion = null;
        this.chairman = null;
        this.members = null;
        this.omsuRepresentative = null;
        this.omsuRepresentativeHelper = null;

        this.reactionKeys = [];
        this.levelKeys = [];

        this.levels = {}; // stageId: level

        if (initObjectParams && initObjectParams['actDate']) {
            this.actDate = initObjectParams['actDate']
        }
        this.initObjectParams = initObjectParams;

        if (initClassProperties) {
            SurveyEventAttributes.stagesMetadata = initClassProperties;
            for (const stage of initClassProperties) {
                this.reactionKeys.push('reactions-' + stage['id']);
                this.levelKeys.push('levels-' + stage['id']);
                Object.assign(this, {['reactions-' + stage['id']]: null})
                Object.assign(this, {['levels-' + stage['id']]: null})
            }
        }
    }

    get getMetadata() {
        return SurveyEventAttributes.stagesMetadata
    }

    static get modelName() {
        return 'ClinicalEvent'
    }

    static get validations() {

        let validations = {
            actNumber: {},
            actDate: {},
            dogHandler: {},
            vetSpecialist: {},
            conclusion: {},
            conclusionChoice: {},
            votedFor: {},
            votedAgainst: {},
            specialOpinion: {},
            chairman: {},
            members: {},
            omsuRepresentative: {},
            omsuRepresentativeHelper: {}
        }

        if (SurveyEventAttributes.stagesMetadata) {
            for (const stage of SurveyEventAttributes.stagesMetadata) {
                validations[`reactions-${stage['id']}`] = {}
                validations[`levels-${stage['id']}`] = {}
            }
        }

        return validations
    }

    static get validationFieldLabels() {
        return {
            actNumber: 'Номер акта',
            actDate: 'Дата составления акта',
            dogHandler: 'Кинолог',
            vetSpecialist: 'Ветеринарный специалист',
            conclusion: 'Заключение',
            conclusionChoice: 'Решение',
            votedFor: 'За',
            votedAgainst: 'Против',
            specialOpinion: 'Наличие особого мнения члена комиссии',
            chairman: 'председателя комиссии',
            members: 'членов комиссии',
            omsuRepresentative: 'в присутствии',
            omsuRepresentativeHelper: 'помощник'
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return ''
    }

    static get newLabel() {
        return ''
    }

    objectLabel() {
        return ''
    }

    applyData(data) {
        this.actNumber = data['actNumber'];
        this.actDate = data['actDate'] ? data['actDate'] : this.initObjectParams['actDate'];
        this.reactions = data['reactions'] ? data['reactions'] : {}
        this.dogHandler = data['dogHandler'];
        this.conclusion = data['conclusion'];
        this.vetSpecialist = data['vetSpecialist'];
        this.conclusion = data['conclusion'];
        this.conclusionChoice = data['conclusionChoice'];
        this.votedFor = data['votedFor'];
        this.votedAgainst = data['votedAgainst'];
        this.specialOpinion = data['specialOpinion'];
        this.chairman = data['chairman'];
        this.members = data['members'];
        this.omsuRepresentative = data['omsuRepresentative'];
        this.omsuRepresentativeHelper = data['omsuRepresentativeHelper'];

        this.levels = data['levels']

        if (SurveyEventAttributes.stagesMetadata) {
            for (const stage of SurveyEventAttributes.stagesMetadata) {
                const stageId = `reactions-${stage['id']}`;
                this[stageId] = data[stageId];
                const levelId = `levels-${stage['id']}`;
                this[levelId] = data[levelId];
            }
        }

    }

}